import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { AUTH_FOOTER } from '../../utils';
import { RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';


@Component({
  selector: 'app-auth-footer',
  templateUrl: './auth-footer.component.html',
  styleUrls: ['./auth-footer.component.scss'],
  standalone: true,
  imports: [RouterLinkActive, MatDividerModule, MatFormFieldModule, TranslateModule]
})
export class AuthFooterComponent implements OnInit {

  public linksFooter = AUTH_FOOTER;
  public year = new Date().getFullYear();
  public version: string = environment.version;

  ngOnInit(): void { }

  onNavigate(): void {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

}
